export default __webpack_public_path__ + "static/media/Andhra_Normal.a7ad0f04.svg";